import { render, staticRenderFns } from "./sanctionsEnforcementsComponent.vue?vue&type=template&id=3ee730e2"
import script from "./sanctionsEnforcementsComponent.vue?vue&type=script&lang=js"
export * from "./sanctionsEnforcementsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports